import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'num_of_weekly_rest_days_at_least_24_consecutive_hours_long_prov'

export const dataPointDefinition = {
  retracedId: 'num_of_weekly_rest_days_at_least_24_consecutive_hours_long_prov',
  name: 'Number of weekly rest days (at least 24 consecutive hours long) provided by the facility:',
  description:
    "This question refers to the facility's general policy on rest days and refers only to normal contracted working hours. \r\r\n\r\r\nOvertime on weekly rest days is covered separately.\r\r\n\r\r\nIf the facility provides a weekly rest day, but it is only for 20 consecutive hours (for example), do not count that day as a rest day. ",
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wh-wor-20',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6820,
  sectionId: '2.2.12',
  impactArea: 'Working Hours',
  impactAreaId: 'WORKING_HOURS_AND_OVERTIME',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
